import React, { useState, useEffect, useRef, useMemo, } from 'react';
import styled from '../../../../styled';
import { ColumnButton } from '../../date/Calendar/Column';
const numberColHeight = 44;
const Container = styled.div `
  display: flex;
  border-radius: 0.5rem;
`;
const Grid = styled.div `
  width: 3.5rem;
  max-height: 17.875rem;
  overflow-y: auto;
  border-left: 0.0625rem solid ${({ theme }) => theme.colors.INK_200};
  &::last-child {
    border-left: none;
  }
  &::-webkit-scrollbar {
    display: none;
  }
`;
const Column = styled(ColumnButton) `
  width: 100%;
  height: 2.755rem;

  :hover {
    border-radius: 0;
  }
`;
const getTimeString = (time) => time.toString().padStart(2, '0');
const Select = ({ length, value, onClick }) => {
    const prevValue = useRef(value);
    const ref = useRef(null);
    const numbers = useMemo(() => new Array(length).fill(null).map((_, i) => getTimeString(i)), [length]);
    useEffect(() => {
        if (!ref.current)
            return;
        const top = value ? parseInt(value, 10) * numberColHeight : 0;
        if (prevValue.current !== value) {
            ref.current.scrollTo({
                top,
                behavior: 'smooth',
            });
            prevValue.current = value;
        }
        else {
            ref.current.scrollTop = top;
        }
    }, [value]);
    return (React.createElement(Grid, { ref: ref }, numbers.map((number) => (React.createElement(Column, { id: number, key: number, isSelected: number === value, onClick: () => onClick(number) }, number)))));
};
const TimerDropdown = ({ value, onSelect }) => {
    const [hour, minute, second] = value ? value.split(':') : [];
    const [selectedHour, setSelectedHour] = useState(hour);
    const [selectedMinute, setSelectedMinute] = useState(minute);
    const [selectedSecond, setSelectedSecond] = useState(second);
    useEffect(() => {
        if (selectedHour && selectedMinute && selectedSecond) {
            const time = `${selectedHour}:${selectedMinute}:${selectedSecond}`;
            if (time !== value) {
                onSelect(time);
            }
        }
    }, [onSelect, selectedHour, selectedMinute, selectedSecond, value]);
    return (React.createElement(Container, null,
        React.createElement(Select, { length: 24, value: selectedHour, onClick: setSelectedHour }),
        React.createElement(Select, { length: 60, value: selectedMinute, onClick: setSelectedMinute }),
        React.createElement(Select, { length: 60, value: selectedSecond, onClick: setSelectedSecond })));
};
export default TimerDropdown;
//# sourceMappingURL=TimerDropdown.js.map